import { getConfig, getVariableValue, getVariableVariable, isWeb } from '@tamagui/core';
import type { FontSizeTokens, GenericFont } from '@tamagui/core';

type NamedFontSizeTokens = Exclude<FontSizeTokens, number>;

export const getFontTokens = (fontKey = '$body'): GenericFont<NamedFontSizeTokens> => {
  return getConfig().fontsParsed[fontKey];
};

export const getFontSizeTokens = (fontKey = '$body') => {
  return getFontTokens(fontKey).size;
};

export const getLineHeightTokens = (fontKey = '$body') => {
  return getFontTokens(fontKey).lineHeight;
};

export const getLetterSpacingTokens = (fontKey = '$body') => {
  return getFontTokens(fontKey).letterSpacing;
};

export const getFontWeightTokens = (fontKey = '$body') => {
  return getFontTokens(fontKey).weight;
};

export const getFontTokenKeys = (fontKey = '$body') => {
  const fontSizeTokens = getFontSizeTokens(fontKey);
  return Object.keys(fontSizeTokens) as Array<keyof typeof fontSizeTokens>;
};

type FontProperty = keyof Pick<
  GenericFont<NamedFontSizeTokens>,
  'size' | 'lineHeight' | 'letterSpacing' | 'weight'
>;

export const getTypographyCSSVariable = (
  token: NamedFontSizeTokens,
  property: FontProperty,
  fontKey = '$body',
) => {
  return getVariableVariable(getFontTokens(fontKey)[property]?.[token]);
};

export const getFontName = (
  weight: '400' | '500' | '600' | '800' = '400',
  fontKey = '$body',
  isForWeb = isWeb,
) => {
  if (isForWeb) {
    const family = getFontTokens(fontKey)['family'];
    return getVariableValue(family);
  }
  const fontFace = getFontTokens(fontKey)['face']?.[weight]?.normal;
  return getVariableValue(fontFace);
};

export const getTypographyValue = (
  token: NamedFontSizeTokens,
  property: FontProperty,
  fontKey = '$body',
) => {
  const variable = getFontTokens(fontKey)[property]?.[token];
  return getVariableValue(variable);
};
